import axios from 'axios';
import { map } from 'lodash';
import camelcaseKeys from 'camelcase-keys';

import { propertyFromApi } from '../../../property_api';

import { clearFilters } from '../actions/query';
import { retrieveRecords } from '../actions/search';
import { duplicatePropertiesPath } from '../selectors/paths';

export const CHANGE_DUPLICATE_PROPERTIES_PAGE = 'CHANGE_DUPLICATE_PROPERTIES_PAGE';
export function changeDuplicatePropertiesPage(page) {
  return { page, type: CHANGE_DUPLICATE_PROPERTIES_PAGE };
}

export const RESET_DUPLICATES_STATE = 'RESET_DUPLICATES_STATE';
export function resetDuplicatesState() {
  return { type: RESET_DUPLICATES_STATE };
}

export const SET_DUPLICATE_PROPERTIES = 'SET_DUPLICATE_PROPERTIES';
export function setDuplicateProperties({ duplicates, page, pageSize, totalCount }) {
  return { type: SET_DUPLICATE_PROPERTIES, duplicates, page, pageSize, totalCount };
}

export const START_LOADING = 'START_DUPLICATES_LOADING';
export function startLoading() {
  return { type: START_LOADING };
}

export const SHOW_DUPLICATES = 'SHOW_DUPLICATES';
export function showDuplicates() {
  return { type: SHOW_DUPLICATES };
}

export const HIDE_DUPLICATES = 'HIDE_DUPLICATES';
export function hideDuplicates() {
  return { type: HIDE_DUPLICATES };
}

export function retrieveDuplicates(page = 1) {
  return (dispatch, getState) => {
    const state = getState();
    const path = duplicatePropertiesPath(state);
    dispatch(startLoading());

    return axios.get(path, { params: { page } }).then((response) => {
      const { data } = response;
      const params = {
        duplicates: map(data.duplicates, ({ properties, ...dupFromApi }) => {
          const duplicate = camelcaseKeys(dupFromApi);
          duplicate.properties = map(properties, property => propertyFromApi(property));
          return duplicate;
        }),
        page: data.page,
        pageSize: data.page_size,
        totalCount: data.total_count
      };
      dispatch(setDuplicateProperties(params));
    });
  };
}

export function toggleView(viewActive) {
  return (dispatch) => {
    if (viewActive) {
      dispatch(showDuplicates());
      dispatch(retrieveDuplicates());
    } else {
      dispatch(hideDuplicates());
      dispatch(clearFilters());
      dispatch(retrieveRecords());
    }
  };
}
